import { YOO_FINDS_H5_CDN_URL } from "@/common/domains";
const ROOT = `${YOO_FINDS_H5_CDN_URL}/h5/activity/2026/worldcup`;

export const WORLDCUP_LOGO = `${ROOT}/worldcupLogo.png?imageMogr2/thumbnail/!80p/format/webp`;
export const WORLDCUP_LOGO_BOTTOM = `${ROOT}/worldcupLogoBottom.png?imageMogr2/thumbnail/!80p/format/webp`;
